import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Inject, Optional } from '@angular/core';
import { Router } from "@angular/router";
import { ApiService } from '../../api.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EventEmitter, Output } from '@angular/core';
import { FileQueueObject, FileuploadService } from '../../fileupload.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { disclaimer, getStringSizeInBytes, MAIL_SIGNATURE, maxMailSizeMB } from '../../shared/constants';
import { NavbarComponent } from '../../navbar/navbar.component';
declare var $: any;

@Component({
	selector: 'app-compose-mail',
	templateUrl: './compose-mail.component.html',
	styleUrls: ['./compose-mail.component.scss', '../../../assets/styles/mailbox.scss']
})
export class ComposeMailComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('fileUploaderComponent') fileUploaderComponent!: FileUploaderComponent;
	items: any = [];
	showLoader = false;
	public emailvalidators: any = [this.emailPatternValidator];
	public emailerrormessages = { 'emailerr': 'Please enter valid email-id' };
	form: FormGroup = this.fb.group({
		mail: [null]
	});

	constructor(private fb: FormBuilder, private toastr: ToastrService, private apiService: ApiService, private router: Router, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void {
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.form.get('mail')?.patchValue({
					toMail: null,
					ccMail: null,
					subject: null,
					body: user.email_signature || MAIL_SIGNATURE
				});
			}
		})
	}

	emailPatternValidator(control: FormControl) {
		const regex = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z.]{2,5}$/;
		if (!control.value.match(regex)) {
			return {
				'emailerr': true
			};
		}
		return null;
	}

	ngAfterViewInit() { }

	ngOnDestroy() {
		$('[id*="richtexteditor"]').hide();;
	}

	saveMail(action: string) {
		let err: String[] = [];
		if (!this.form.value.mail.toMail || !this.form.value.mail.toMail.length) {
			err.push("To");
		}
		if (!this.form.value.mail.subject) {
			err.push("Subject");
		}
		if (!this.form.value.mail.body) {
			err.push("Body");
		}
		if (err.length) {
			this.toastr.info("Please provide " + err.join(", "), 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let attachment = this.fileUploaderComponent.getAttachments();
		let cc: any = this.form.value.mail.ccMail;
		if (cc == null) {
			cc = [];
		}
		let mailContent = this.form.value.mail.body;
		const container = document.createElement('div');
		container.innerHTML = mailContent;
		const cells = container.querySelectorAll('th, td');
		cells.forEach((cell) => {
			if (cell instanceof HTMLElement) {
				cell.style.border = '1px solid black';
			}
		});
		mailContent = container.innerHTML;
		let totalSize = getStringSizeInBytes(mailContent);
		for (let i = 0; i < attachment.length; i++) {
			totalSize += attachment[i].size;
		}
		let sizeInMB = totalSize / 1024 / 1024;
		if (sizeInMB >= maxMailSizeMB) {
			this.toastr.error("Mail size exceeds " + maxMailSizeMB + "MB", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let successMsg = "";
		let pathAfterSuccess = "";
		let mailObj: any = {
			to: JSON.stringify(this.form.value.mail.toMail),
			cc: JSON.stringify(cc),
			subject: this.form.value.mail.subject,
			content: mailContent,
			attachment: JSON.stringify(attachment)
		}
		if (action == "create_draft") {
			mailObj["email_status"] = "draft";
			successMsg = "Draft saved successfully";
			pathAfterSuccess = "draft";
		} else if (action == "compose_mail") {
			mailObj["email_status"] = "sent";
			mailObj["content"] += disclaimer;
			successMsg = "Mail sent successfully";
			pathAfterSuccess = "outgoing";
		}
		this.showLoader = true;
		this.apiService.saveMail(mailObj).subscribe({
			next: (data) => {
				this.showLoader = false;
				this.toastr.info(successMsg, 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.router.navigate(['/app/mailbox/folder', pathAfterSuccess]);
			}, error: (error) => {
				this.showLoader = false;
				if (typeof error.error == "string") {
					this.toastr.error(error.error, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				} else {
					this.toastr.error("Something went wrong.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}
}